mod.modules.define("Valuation", "BaseModule", function(fn) {
	"use strict";

	var cache = {
		$table : null,
		$tableBodies : null
	};

	fn.prototype.init = function(params) {
		this.base("init", params);

		//VL-396 - Quick change to check parent.   If the parent is LI then it's in docked mode.. 
		//if not, it's in zoomed mode and this is messing up the cache.
		if (this.$el.parent().is("li")) {
			// Cache
			cache.$table = this.el.find("table.data");
			cache.$tableBodies = cache.$table.find("tbody");
		}
	};

	fn.prototype.events = {
		".scroll-chiclet:not(.selected)" : {
			"click" : function(e, $el) {
				// Scroll to the new index
				var index = parseInt($el.attr("data-index"));

				// Show the correct tbody
				cache.$tableBodies.hide();
				cache.$tableBodies.eq(index).show();

				// Highlight this chiclet
				$el.siblings().removeClass("selected");
				$el.addClass("selected");
			}
		},
		".valuation-charttoggle" : {
			"click" : function(e, $el) {
				var enableChart = $el.attr("data-enablechart");

				this.reload({
					ShowChart : enableChart
				});
			}
		},
		"button[data-showtrend]" : {
			"click" : function(e, $el) {
				var revealTrend = JSON.parse($el.attr("data-showtrend"));

				// Switch the table attribute to hide/show cols
				cache.$table.attr("data-showtrend", revealTrend);

				if (revealTrend) {
					cache.$table.find(".valuation-cell-trend").addClass("visible");
					cache.$table.find(".valuation-cell-estimate").addClass("hidden");

				} else {
					cache.$table.find(".valuation-cell-trend").removeClass("visible");
					cache.$table.find(".valuation-cell-estimate").removeClass("hidden");
				}

				// Fix the button for the next go 'round
				var newText = (revealTrend) ? "Hide trend" : "Show trend";
				$el.find("span").text(newText);
				$el.attr("data-showtrend", !revealTrend);
			}
		}
	};

});